import { ContentWrap, Space16, Space24, Space8 } from 'styles'
import { memo, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useModal } from '../../store/app/hooks'
import { updateDepositAmountAction } from '../../store/deposit/actions'
import { DepositAssets } from './DepositAssets'
import { DepositAmount } from './DepositAmount'
import { DepositReceive } from './DepositReceive'
import { FromTip } from './styles'
import { DepositConfirmModal } from './DepositConfirmModal'
import { DepositButton } from './DepositButton'
import { getEvmRecentConnection } from '../../connection/meta'
import { DepositToAddress } from './DepositToAddress'
import { WalletNames } from '../../connection/utils'
import { styled } from '@mui/material'
import { ReactComponent as IconReceive } from './assets/receive.svg'
import { DepositNetworks } from './DepositNetworks'
import { DepositCurrencies } from './DepositCurrencies'

const ReceiveLine = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 32px;
  position: relative;

  .line {
    flex: 1;
    height: 1px;
    background-color: rgba(58, 80, 25, 1);
  }
`

export const DepositContent = memo(() => {
  const dispatch = useDispatch()
  const modal = useModal('deposit')

  useEffect(() => {
    if (!modal) {
      dispatch(updateDepositAmountAction(''))
    }
  }, [dispatch, modal])

  const { name } = getEvmRecentConnection()?.getProviderInfo() ?? {
    name: WalletNames.METAMASK,
  }

  return (
    <ContentWrap>
      <DepositToAddress />
      <FromTip>Network</FromTip>
      <Space8 />
      <DepositNetworks />
      <Space8 />
      <FromTip>Token</FromTip>
      <Space8 />
      <DepositCurrencies />
      <Space16 />
      <FromTip>
        <b>From</b> {name}
      </FromTip>
      <Space8 />
      <DepositAmount />
      <Space24 />
      <ReceiveLine>
        <i className="line" />
        <IconReceive />
        <i className="line" />
      </ReceiveLine>
      <Space24 />

      <DepositReceive />
      <Space24 />
      <DepositButton />
      <DepositConfirmModal />
    </ContentWrap>
  )
})
